import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { app } from "~/services/firebase";
import { v4 as uuidv4 } from "uuid";

export default async function uploadFile(file, path = "") {
  let files = {};
  const fileUuid = uuidv4();
  const nameSplit = file.name.split(".");
  const type = nameSplit[nameSplit.length - 1];

  const storage = getStorage(app);
  const local = path
    ? path + "/" + fileUuid + "." + type
    : fileUuid + "." + type;
  const imageRef = ref(storage, local);
  await uploadBytes(imageRef, file).then(async (snapshot) => {
    await getDownloadURL(snapshot.ref).then((downloadURL) => {
      files = {
        url: downloadURL,
        name: fileUuid + "." + type,
        size: file.size,
      };
    });
  });
  return files;
}

// export function organizeMultiAndSingleFiles(documents, path = "") {
//   return documents.map(async (document) => {
//     if (document.file_id) {
//       if (typeof document.file_id.length === "undefined") {
//         const { name = "file", type = "pdf" } = document.file_id;
//         let myPromise = await uploadFile(document.file_id, path);
//         return Promise.all([myPromise]).then((files) => {
//           const { name: key } = files[0];
//           return {
//             ...files[0],
//             key,
//             name: name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
//             type,
//             document_id: document.document_id,
//           };
//         });
//       } else {
//         return Array.from(document.file_id)
//           .sort((a, b) => a.size > b.size)
//           .map(async (file) => {
//             const { name, type } = file;
//             let myPromise = await uploadFile(file, path);
//             return Promise.all([myPromise]).then((files) => {
//               const { name: key } = files[0];
//               return {
//                 ...files[0],
//                 key,
//                 name: name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
//                 type,
//                 document_id: document.document_id,
//               };
//             });
//           });
//       }
//     }
//   });
// }

export function organizeMultiAndSingleFiles(documents, path = "") {
  // O map externo agora retorna um array de Promises
  return documents.map(async (document) => {
    // Garante que 'file_id' existe para prosseguir. Se não existir, retorna undefined/null.
    if (!document.file_id) {
      return null;
    }

    const documentId = document.document_id;
    const fileId = document.file_id;

    // Verifica se 'file_id' é um array/lista (indicando múltiplos arquivos).
    // Nota: 'file_id.length' é a forma mais robusta de verificar um Array.
    if (
      Array.isArray(fileId) ||
      (fileId.length !== undefined && typeof fileId !== "string")
    ) {
      // Caso Múltiplos Arquivos
      // 1. Converte para Array (se já não for) e ordena.
      const filesArray = Array.from(fileId).sort((a, b) => a.size - b.size);

      // 2. Mapeia e processa todos os arquivos em paralelo.
      const uploadPromises = filesArray.map((file) =>
        processAndFormatFile(file, path, documentId)
      );

      // 3. Aguarda todos os uploads. Retorna um Array de resultados.
      return Promise.all(uploadPromises);
    } else {
      // Caso Arquivo Único (fileId é o próprio objeto File/Blob)
      // Chama a função auxiliar e retorna o resultado.
      return processAndFormatFile(fileId, path, documentId);
    }
  });
}

async function processAndFormatFile(file, path, documentId) {
  const { name = "file", type = "pdf" } = file;

  // 1. Faz o upload e aguarda o resultado.
  const uploadedFile = await uploadFile(file, path);

  // 2. Normaliza o nome e retorna o objeto formatado.
  const normalizedName = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const key = uploadedFile.name; // Presumindo que o nome retornado pelo upload é a "key"

  return {
    ...uploadedFile,
    key,
    name: normalizedName,
    type,
    document_id: documentId,
  };
}
